module.exports = __webpack_public_path__ + "static/media/Logo.9eb8f75f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Logo.png
// module id = 35
// module chunks = 0